import submit from '@mailobj-browser/front/js/events/types/submit.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { fromEvent } from '#utilities/js/ea/ajax.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import alert from '#utilities/js/ea/alert.js'
import confirm from '#utilities/js/ea/confirm.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { elements, helpers } from '#components/generics/js/styles.js'
import { elements as elementsXfiles } from '#components/generics/js/xfiles/styles.js'
import { hasAttachedFile } from '#components/generics/js/xfiles/add/backdrop.js'
import { close } from '#utilities/js/lightboxes/lightbox.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import { shim } from '#utilities/js/ea/submitter.js'

const typeCases = object(null, {
  0: (dftQuota, linkQuota) => {
    return dftQuota
  },
  1: (dftQuota, linkQuota) => {
    return linkQuota
  }
})

const sourceCases = object(null, {
  attach: (form, quota) => {
    for (const checkbox of all('[type="checkbox"][name="att[]"]', form)) {
      if (checkbox.checked) {
        const { dataset } = checkbox
        const { scopeJson } = dataset
        const json = JSON.parse(scopeJson)

        if (json.size) {
          quota = quota - json.size
        }
      }
    }
    return quota
  },
  camera: (form, quota) => {
    return quota
  },
  docs: (form, quota) => {
    for (const checkbox of all('[type="checkbox"][name="docs[]"]', form)) {
      if (checkbox.checked) {
        const { dataset } = checkbox
        const { scopeJson } = dataset
        const json = JSON.parse(scopeJson)

        if (json.size) {
          quota = quota - json.size
        }
      }
    }
    return quota
  },
  draw: (form, quota) => {
    return quota
  },
  hd: (form, quota) => {
    const { files } = one('[type="file"][name="upload[]"]', form)
    for (const { size } of files) {
      quota = quota - size
    }
    return quota
  },
  pgp: (form, quota) => {
    return quota
  },
  vcard: (form, quota) => {
    return quota
  }
})

const onSubmit = object(listener, {
  type: submit,
  passive,
  task: async (
    modalForm,
    event
  ) => {
    const modal = closest(`.${elements.modal}`, modalForm)
    const { dataset } = modalForm
    const { alert: msgAlert, confirm: msgConfirm, scopeJson } = dataset
    const sendAsLinks = JSON.parse(msgConfirm)
    const xfilesAttach = one(`.${elementsXfiles.xfiles_attach}`, modal)
    // let resultFileAttached
    let ok = true

    if (scopeJson) {
      const json = JSON.parse(scopeJson)
      const modalAttachLinks = one('[type="hidden"][name="msg_attach_links"]', modalForm)
      const { value } = modalAttachLinks
      const { submitter } = shim(event)
      const { form: mainForm } = submitter
      const pj = all(`.${helpers.xfiles.elements.xfiles_item}`, mainForm)
      let available = typeCases[value](json.dftQuota, json.linkQuota)

      for (const { dataset } of pj) {
        const { scopeJson } = dataset
        if (scopeJson) {
          const s = JSON.parse(scopeJson)

          if (s) {
            available -= s.size
          }
        }
      }

      const xFilesAttach = one(`.${helpers.xfiles.elements.xfiles_attach}`, modal)
      if (xFilesAttach) {
        const { dataset } = xFilesAttach
        const { showXfiles } = dataset

        available = sourceCases[showXfiles]?.(modalForm, available)
      }

      if (available <= 0) {
        /*if (value && value === 1) {
          if (msgAlert) {
            await alert(msgAlert)
            ok = false
          }
        } else */
        if (sendAsLinks) {
          const { title: titleSendAsLinks, text: textSendAsLinks } = sendAsLinks
          const result = await confirm(titleSendAsLinks, textSendAsLinks)

          if (result) {
            modalAttachLinks.value = 1

            const mainAttachLinks = one('[type="hidden"][name="msg_attach_links"]', mainForm)
            if (mainAttachLinks) {
              mainAttachLinks.value = 1
            }
          } else {
            ok = false
          }
        }
      }
    }

    hasAttachedFile(modal)

    if (xfilesAttach && !xfilesAttach.classList.contains(elementsXfiles.xfiles_attach_has_file_attached)) {
      await alert(msgAlert)
      ok = false
    }

    if (ok) {
      await fromEvent(modalForm, event)
      close()
    }
  }
})

export default (
  form
) => {
  onSubmit.listen(form)
}